import React, { useState, useEffect } from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";

import { DistributorWholeCommandCell } from "./DistributorWholeCommandCell";

const editField = "inEdit";

const DistributorGrid = ({
  distributors,
  setDistributorData,
  distributorParentCompanies,
  isEditMode,
  setIsEditMode,
  isReadOnly,
}) => {
  const [originalDistributors, setOriginalDistributors] = useState();

  const [showEmptyDropdownError, setShowEmptyDropdownError] = useState();

  const remove = (dataItem) => {
    const updated = distributors.filter(
      (item) => item.idLocal != dataItem.idLocal
    );

    setDistributorData(updated);
  };

  const update = (dataItem) => {
    let localId = Number(dataItem.idLocal);

    if (!dataItem.parentCompanyId) {
      setShowEmptyDropdownError(true);
      return;
    }

    if (localId == 0)
      localId = Math.max(...distributors.map((t) => t.idLocal)) + 1;

    let updated = distributors.map((item) =>
      item.idLocal === dataItem.idLocal
        ? {
            ...item,
            idLocal: localId,
            parentCompanyId: dataItem.parentCompanyId,
            accountNumber: dataItem.accountNumber,
            alternateAccountNumber: dataItem.alternateAccountNumber,
            tertiaryAccountNumber: dataItem.tertiaryAccountNumber,
            name: dataItem.name,

            inEdit: false,
          }
        : item
    );

    setDistributorData(updated);
    setIsEditMode(false);
  };

  const cancel = (dataItem) => {
    setDistributorData(originalDistributors);
    if (showEmptyDropdownError) setShowEmptyDropdownError(false);
    setIsEditMode(false);
  };

  const enterEdit = (dataItem) => {
    const original = distributors.map((item) => ({ ...item, inEdit: false }));
    setOriginalDistributors(original);

    setDistributorData(
      distributors.map((item) =>
        item.idLocal === dataItem.idLocal ? { ...item, inEdit: true } : item
      )
    );
    setIsEditMode(true);
  };

  const itemChange = (event) => {
    const newData = distributors.map((item) =>
      item.idLocal === event.dataItem.idLocal
        ? { ...item, [event.field || ""]: event.value }
        : item
    );
    setDistributorData(newData);
  };

  const addNew = () => {
    const original = distributors.map((item) => ({ ...item, inEdit: false }));
    setOriginalDistributors(original);
    let localId=0;
    if (original.length == 0) localId=1;
    else 
    localId = Math.max(...distributors.map((t) => t.idLocal)) + 1;

    const newDataItem = {
      idLocal: localId,
      accountNumber: "",
      alternateAccountNumber: "",
      tertiaryAccountNumber: "",
      name: "",
      inEdit: true,
    };
    setDistributorData([...distributors,newDataItem]);

    setIsEditMode(true);
  };

  const CommandCell = (props) => (
    <DistributorWholeCommandCell
      {...props}
      edit={enterEdit}
      remove={remove}
      update={update}
      cancel={cancel}
      editField={editField}
    />
  );

  const DistributorWholeParentCompanyDropdown = (props) => {
    const { dataItem, field } = props;

    const itemRender = (li) => {
      const itemChildren = (
        <span className="distribWholeSmallDropdownFont">
          {li.props.children}
        </span>
      );
      return React.cloneElement(li, li.props, itemChildren);
    };

    function handleDropdownValueChange(e) {
      let selectedCompany = distributorParentCompanies.find(
        (x) => x.wpid == e.value.wpid
      );

      const updated = distributors.map((item) =>
        item.idLocal == dataItem.idLocal
          ? {
              ...item,
              parentCompanyId: selectedCompany.wpid,
              name: selectedCompany.name,
            }
          : item
      );

      setDistributorData(updated);
    }
    return (
      <td>
        {dataItem.inEdit ? (
          <>
            <DropDownList
              style={{
                width: "100%",
              }}
              itemRender={itemRender}
              data={distributorParentCompanies}
              textField="name"
              //dataItemKey="wpid"
              value={distributorParentCompanies.find(
                (x) => x.wpid == dataItem.parentCompanyId
              )}
              onChange={handleDropdownValueChange}
            />

            {showEmptyDropdownError && (
              <div className="text-danger">Selection is required</div>
            )}

            {/* <input
              type="text"
              className="form-control form-control-sm uppercase"
              defaultValue={dataItem[field]}
            /> */}
            {/* {errors.editLicenseNum && (
              <p className="text-danger">{errors.editLicenseNum.message} </p>
            )} */}
          </>
        ) : (
          dataItem[field]
        )}
      </td>
    );
  };

  return (
    <>
      <h6>Distributor List</h6>
      {/* <form onSubmit={handleSubmit(onSubmit)}>
        </form> */}
      <Grid data={distributors} onItemChange={itemChange} editField={editField}>
        <GridColumn
          field="name"
          title="Distributor"
          cell={DistributorWholeParentCompanyDropdown}
        />
        <GridColumn field="accountNumber" title="Account Number" />
        <GridColumn field="alternateAccountNumber" title="Alt Account Number" />

        {/* <GridColumn
          field="tertiaryAccountNumber"
          title="Tertiary Account Number"
        /> */}

        {!isReadOnly && (
          <GridColumn
            cell={CommandCell}
            props={(isEditMode, setIsEditMode)}
            width="200px"
          />
        )}
      </Grid>

      <GridToolbar>
        <button
          title="Add new"
          className="btn btn-primary"
          onClick={addNew}
          disabled={isReadOnly || isEditMode}
        >
          Add New Distributor
        </button>
      </GridToolbar>
    </>
  );
};

export default DistributorGrid;
